import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "Q3831",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "SexName",
    isNumber: true,
  },
];

export const VillageToHighRiskFactor = {
  label: "鄉鎮 VS 高風險因子",
  key: "VillageToHighRiskFactor",
  path: "BoneMuscleCare/VillageToHighRiskFactor",
  api: "TCS_V_HighRiskStatics01V",
  render: (options) => (
    <Diagram.BoneMuscleCare.VillageToHighRiskFactor {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "RegionName",
      field: "RegionName",
      header: "",
    },
  ],
  filterColumns: [{ key: "Q3967", type: "date" }],
  levelColumns,
  columns: [],
};
